<ul class="header-panel">
  <li class="header-panel__item header-panel__item--menu">
    <button
      class="icon-button p-2 eye-border eye-hover eye-rounded"
      (click)="toggleMenu()"
      title="{{
        !isMenuOpen ? ('MENU_OPEN' | translate) : ('MENU_CLOSE' | translate)
      }}"
      attr.aria-label="{{
        !isMenuOpen ? ('MENU_OPEN' | translate) : ('MENU_CLOSE' | translate)
      }}"
    >
      <img
        class="eye-d-none"
        [src]="
          isMenuOpen
            ? '../assets/img/icons/close.svg'
            : '../assets/img/icons/menu.svg'
        "
        width="20"
        alt=""
      />
      <span class="d-none eye-d-block">
        <fa-icon [icon]="faBars"></fa-icon>
        {{
          !isMenuOpen ? ('MENU_OPEN' | translate) : ('MENU_CLOSE' | translate)
        }}
      </span>
    </button>
  </li>
  <li class="header-panel__item header-panel__item--logo">
    <a
      [routerLink]="['/'] | localize"
      routerLinkActive="current"
      [routerLinkActiveOptions]="{ exact: true }"
      title="{{ 'GO_TO_HOME' | translate }}"
      class="d-block eye-hover"
    >
      <picture>
        <source
          srcset="
            ../assets/img/logos/logo-mini.png,
            ../assets/img/logos/logo-mini@2x.png 2x,
            ../assets/img/logos/logo-mini@3x.png 3x
          "
          media="(max-width: {{ '575px' }})"
        />
        <img
          class="header-panel__logo eye-d-none"
          src="../assets/img/logos/logo-light_{{ lang }}.png"
          srcset="../assets/img/logos/logo-light_{{ lang }}@2x.png 2x, ../assets/img/logos/logo-light_{{ lang }}@3x.png 3x"
          alt="{{ 'LOGO_COMPANY' | translate }}"
        />
        <div
          class="header-panel__logo d-none eye-d-block"
          [inlineSVG]="'../assets/img/logos/logo-square.svg'"
        ></div>
      </picture>
    </a>
  </li>
  <li class="header-panel__item d-none d-sm-block">
    <p
      class="header-panel__desc eye-lh-normal"
      [innerHTML]="'LOGO_DESC' | translate"
    ></p>
  </li>
  <li class="header-panel__item d-sm-none">
    <app-lang-selector></app-lang-selector>
  </li>
  @if (session) {
    <li
      class="header-panel__item position-relative header-panel__item--user"
      dropdown
      #dropdown="bs-dropdown"
      (mouseenter)="dropdown.show()"
      (mouseleave)="dropdown.hide()"
    >
      <a
        class="user-button user-button--transparent d-block"
        [routerLink]="['/personal'] | localize"
      >
        <div
          class="user-button__icon"
          [inlineSVG]="'../assets/img/icons/account.svg'"
        ></div>
        <span class="user-button__text">{{
          session.phone || session.email
        }}</span>
        @if (notificationsCounter$ | async) {
          <app-notification-counter [counterValiant]="'small'">
          </app-notification-counter>
        }
        <button
          type="button"
          dropdownToggle
          stopPropagation
          (click)="$event.preventDefault(); dropdown.triggers = ''"
        >
          <fa-icon
            [icon]="faChevronDown"
            class="header-chevron header-panel__chevron"
            [class.rotate-180]="dropdown.isOpen"
            [fixedWidth]="true"
          ></fa-icon>
        </button>
      </a>
      <ul
        *dropdownMenu
        class="header-panel__dropdown header-dropdown shadow"
        role="menu"
        (mouseleave)="dropdown.hide()"
      >
        <li role="menuitem">
          <a class="pointer" (click)="logout()">{{ 'LOGOUT' | translate }}</a>
        </li>
      </ul>
    </li>
  } @else {
    <li class="header-panel__item header-panel__item--user">
      <button
        class="user-button user-button--transparent"
        (click)="openLogin()"
      >
        <div
          class="user-button__icon"
          [inlineSVG]="'../assets/img/icons/account.svg'"
        ></div>
        <span>{{ 'LOG_IN' | translate }}</span>
      </button>
    </li>
  }

  <li
    class="header-panel__item contacts"
    (mouseenter)="isOpenContactsInfo = true"
    (mouseleave)="isOpenContactsInfo = false"
  >
    @if (!isOpenContactsInfo) {
      <a class="contacts__header">
        <span [inlineSVG]="'../assets/img/icons/headphones-white.svg'"></span>
        <span class="contacts__header_title">{{
          'CONTACTS.CENTER' | translate
        }}</span>
        <span
          [inlineSVG]="'../assets/img/icons/chevron-down-white.svg'"
          class="contacts__popup_arrow"
        ></span>
      </a>
    }
    @if (isOpenContactsInfo) {
      <a class="contacts__popup">
        <div class="contacts__header">
          <span [inlineSVG]="'../assets/img/icons/headphones-black.svg'"></span>
          <span
            class="contacts__popup_title"
            [routerLink]="['/Pomoshch0/Call-tsentr154'] | localize"
            >{{ 'CONTACTS.CENTER' | translate }}</span
          >
          <span
            [inlineSVG]="'../assets/img/icons/chevron-down-black.svg'"
          ></span>
        </div>
        <div class="contacts__popup_container">
          <div class="contacts__popup_block">
            <div class="contacts__popup_block-title">
              {{ 'CONTACTS.SHORT_PHONE' | translate }}
            </div>
            <a class="contacts__popup_block-phone" href="tel:154">154</a>
          </div>
          <div class="contacts__popup_block">
            <div class="contacts__popup_block-title">
              {{ 'CONTACTS.PHONE_OPERATOR_NAME_ONE' | translate }}
            </div>
            <a
              class="contacts__popup_block-phone"
              href="tel:{{ 'CONTACTS.PHONE_NUMBER_ONE' | translate }}"
              >{{ 'CONTACTS.PHONE_NUMBER_ONE' | translate }}</a
            >
          </div>
          <div class="contacts__popup_block">
            <div class="contacts__popup_block-title">
              {{ 'CONTACTS.PHONE_OPERATOR_NAME_TWO' | translate }}
            </div>
            <a
              class="contacts__popup_block-phone"
              href="tel:{{ 'CONTACTS.PHONE_NUMBER_TWO' | translate }}"
              >{{ 'CONTACTS.PHONE_NUMBER_TWO' | translate }}</a
            >
          </div>
        </div>
        <div class="contacts__popup_footer">
          {{ 'CONTACTS.PHONE_INFO_POPUP' | translate }}
        </div>
      </a>
    }
  </li>

  <li class="header-panel__item header-panel__item--search">
    <button
      class="icon-button p-2 eye-border eye-hover eye-rounded"
      (click)="toggleSearch()"
      title="{{
        !isSearchOpen
          ? ('SEARCH_OPEN' | translate)
          : ('SEARCH_CLOSE' | translate)
      }}"
      attr.aria-label="{{
        !isSearchOpen
          ? ('SEARCH_OPEN' | translate)
          : ('SEARCH_CLOSE' | translate)
      }}"
    >
      <img
        class="eye-d-none"
        [src]="
          isSearchOpen
            ? '../assets/img/icons/close.svg'
            : '../assets/img/icons/search-icon.svg '
        "
        width="20"
        alt=""
        srcset=""
      />
      <span class="d-none eye-d-block">
        <fa-icon [icon]="faSearch"></fa-icon>
        {{
          !isSearchOpen
            ? ('SEARCH_OPEN' | translate)
            : ('SEARCH_CLOSE' | translate)
        }}
      </span>
    </button>
  </li>
</ul>
@if (false) {
  <div class="header-panel left-block">
    <div class="left-block__content">
      <div class="phone-row">
        <div class="phone-title">
          {{ 'CONTACTS.PHONE_OPERATOR_NAME_ONE' | translate }}
        </div>
        <a
          href="tel:{{ 'CONTACTS.PHONE_NUMBER_ONE_WITHOUT_SPACE' | translate }}"
          class="phone-item"
        >
          {{ 'CONTACTS.PHONE_NUMBER_ONE' | translate }}
        </a>
      </div>
      <div class="phone-row">
        <div class="phone-title">
          {{ 'CONTACTS.PHONE_OPERATOR_NAME_TWO' | translate }}
        </div>
        <a
          href="tel:{{ 'CONTACTS.PHONE_NUMBER_TWO_WITHOUT_SPACE' | translate }}"
          class="phone-item"
        >
          {{ 'CONTACTS.PHONE_NUMBER_TWO' | translate }}
        </a>
        <!-- <div class="phone-item">{{ 'CONTACTS.PHONE_NUMBER_TWO' | translate }}</div> -->
      </div>
      <div class="phone-row-info">{{ 'CONTACTS.PHONE_INFO' | translate }}</div>
    </div>
  </div>
}

@if (isMenuOpen && eyeService.enabled) {
  <div class="eye-main-menu">
    <app-menu-items [isEyeServiceEnabled]="true" />
  </div>
}

@if (isSearchOpen && eyeService.enabled) {
  <div class="eye-main-search">
    <label class="form-control form-control--alt form-control--lg">
      <div class="position-relative">
        <input
          type="search"
          class="pr-5 fix-ios-keyboard"
          name="track_number"
          [attr.aria-label]="'MAIN_SEARCH' | translate"
          placeholder="{{ 'MAIN_SEARCH_PLACEHOLDER' | translate }}"
          appAutofocus
        />
        <button
          type="submit"
          class="postfix icon-button"
          attr.aria-label="{{ 'LANGUAGE_SELECT' | translate }}"
        >
          <div [inlineSVG]="'../assets/img/icons/search-icon-3.svg'"></div>
        </button>
      </div>
    </label>
    <app-menu-items [isEyeServiceEnabled]="true" />
  </div>
}
